module.exports = __webpack_public_path__ + "media/application/images/ui/logo-maori-e23ed64126361fe9c2b1c3149c450278.png";